import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
	content: {
		paddingVertical: '1rem',
		paddingHorizontal: '1rem',
	},
	scrollInner: {
		flexGrow: 1,
	},
});

export default styles;
